import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getLabRows } from "./lab-rows";

export const metadata = {
  tableType: "LaboratoryObservations",
  displayName: "Labs",
  getRows: (bundle: FhirBundleSdk) => getLabRows({ bundle }),
};
